import LocationsFilter from "./locationsFilter";
export default LocationsFilter;
